// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2J_uL","signatureButtonsRight":"ModalSign_signatureButtonsRight__3C38N"};